<template>
    <div>
        <DCard
            padding
        >
            <section class="mb-5">
                <h2 class="h4">
                    {{ __('customers.credit_notes.customer_section') }}
                </h2>
                <DRow>
                    <DCol>
                        <b>{{ __('customers.credit_notes.customer_details.id') }}</b>: {{ customer.id }}
                    </DCol>
                </DRow>
                <DRow>
                    <DCol>
                        <b>{{ __('customers.credit_notes.customer_details.name') }}</b>: {{ customer.billing_firstname }} {{ customer.billing_lastname }}
                    </DCol>
                </DRow>
                <DRow>
                    <DCol>
                        <b>{{ __('customers.credit_notes.customer_details.company') }}</b>: {{ customer.billing_company }}
                    </DCol>
                </DRow>
            </section>
            <Form
                :errors="errors"
                :customer="customer"
                :accounting-products="accountingProducts"
                :credit-note-types="creditNoteTypes"
                :products="products"
                :is-product-required-for-finance-system="isProductRequiredForFinanceSystem"
                :is-finance-system-netsuite="isFinanceSystemNetsuite"
                @preview="preview"
            />
        </DCard>
        <DocumentPreSavePreview
            v-if="pdfSource !== null && numPages !== null"
            :title="__('customers.credit_notes.form.credit_note_preview')"
            :pdf-source="pdfSource"
            :num-pages="numPages"
            :show-modal="showModal"
            @close="showModal = false"
            @confirm="submitData"
        />
        <DModal
            v-model:show="showVatWarningModal"
            :title="__('customers.invoices.vat_invalid_warning.title')"
            :message="__('customers.invoices.vat_invalid_warning.message', { vat: customer.billing_vat_number ?? '' })"
            is-confirm
            is-error
            @confirm="showVatWarningModal = false"
            @dismiss="$inertia.visit($route('customers.customers.invoices.index', { customer: customer.id }))"
        />
    </div>
</template>

<script>
import CustomerBase from '~@/Pages/Customers/Base'
import App from '~@/App.vue'

import Form from '~@/Components/Customers/CreditNotes/Form'
import NProgress from 'nprogress'
import DocumentPreSavePreview from '~@/Components/Customers/DocumentPreSavePreview'
import pdf from 'vue3-pdf'

export default {
    name: 'CustomerInvoiceCreate',
    components: {
        Form,
        DocumentPreSavePreview
    },
    layout: [App, CustomerBase],
    props: {
        customer: {
            type: Object,
            default () {
                return {}
            }
        },
        taxData: {
            type: Object,
            default () {
                return {}
            }
        },
        accountingProducts: {
            type: Array,
            default () {
                return []
            }
        },
        creditNoteTypes: {
            type: Array,
            default () {
                return []
            }
        },
        products: {
            type: Array,
            default: () => { return [] }
        },
        isProductRequiredForFinanceSystem: {
            type: Boolean,
            default: () => { return false }
        },
        isFinanceSystemNetsuite: {
            type: Boolean,
            default: () => { return false }
        },
        vatIdInvalid: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            showModal: false,
            pdfSource: null,
            numPages: null,
            errors: {},
            form: null,
            showVatWarningModal: this.vatIdInvalid
        }
    },
    methods: {
        submitData () {
            this.form.post(this.$route('customers.customers.credit-notes.store', {
                customer: this.customer.id
            }))
        },
        preview (form) {
            this.form = form
            this.pdfSource = null
            this.numPages = null

            window.axios.post(this.$route('customers.customers.credit_notes.preview', {
                customer: this.customer.id
            }), {
                credit_note_type_id: form.credit_note_type_id,
                creditNoteItem: form.creditNoteItem
            }, {
                responseType: 'blob'
            })
                .then(response => {
                    NProgress.done()

                    const blob = new Blob([response.data])

                    this.loading = false
                    this.pdfSource = URL.createObjectURL(blob)

                    pdf.createLoadingTask(this.pdfSource)
                        .promise.then(pdf => {
                            this.numPages = pdf.numPages
                        })

                    this.showModal = true
                })
                .catch((error) => {
                    this.loading = false

                    error.response.data.text().then(text => {
                        const response = JSON.parse(text)

                        this.errors = response.errors

                        // Trigger flash error message for general errors
                        if (response.errors && response.errors.general) {
                            this.$page.props.flash = {
                                errorMessages: response.errors.general.join(', ')
                            }
                        }
                    })
                })
        }
    }
}
</script>
